

























import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class TabNaviEntryTemplate extends Vue {
    activeTabIndex: number | null = null; // activeTabIndex holds the index of the active tab, e.g. first is active -> tab===0

    created() {
        const lastMatchedRecord = this.$route.matched[this.$route.matched.length - 1];
        let toBeSelectedTabFound;
        const origPathBrowserIsAdressing = this.$route.fullPath;
        if (this.$route.meta && origPathBrowserIsAdressing === lastMatchedRecord.path) {
            // we are accessing this tab entry directly, e.g. /stammdaten/tabellen/trampolin
            // as this does not make sense, redirect to the first tab: /stammdaten/tabellen/trampolin/headline

            // e.g.  user accesses /navigation/page1 by clicking a link in the navigation
            //       vuex store has an entry /navigation/page1 -> /navigation/page1/whatever?queryParam=123
            // we forward the user to /navigation/page1/whatever?queryParam=123
            const storeEntryForThisNaviEntry = this.$store.state.route
                .lastRouteSettings[lastMatchedRecord.path];
            let tabToRecoverFound = false;
            if (storeEntryForThisNaviEntry) {
                const targetTabPath = storeEntryForThisNaviEntry.match(/.+(\/.+)$/)[1];
                for (const currentTab of this.$route.meta.children) {
                    if (targetTabPath === '/' + currentTab.path) {
                        this.$router.replace(storeEntryForThisNaviEntry);
                        // valid path found
                        tabToRecoverFound = true;
                    }
                }
            }
            if (!tabToRecoverFound) {
                this.$router.replace(
                    origPathBrowserIsAdressing +
                    '/' +
                    this.$route.meta.children[0].path
                );
            }
        } else {
            // somebody accesses any sub route, e.g. /stammdaten/tabellen/trampolin/headline

            // restore old tab index
            const matchedRouteTabs = lastMatchedRecord.meta.children;
            // remove the matched part from navigation:
            // /stammdaten/tabellen/trampolin/headline -> /headline
            const unmatchedPath = origPathBrowserIsAdressing
                .replace(lastMatchedRecord.path, '')
                .replace(/^\//, '');

            let currentMatchedRouteTabIndex = matchedRouteTabs.length - 1;
            for (
                currentMatchedRouteTabIndex;
                currentMatchedRouteTabIndex > -1;
                currentMatchedRouteTabIndex--
            ) {
                const currentMatchedRouteTab =
                    matchedRouteTabs[currentMatchedRouteTabIndex];
                // /headline matches /headline?
                const currentPath = currentMatchedRouteTab.path;
                const firstUnmatchedPart = unmatchedPath
                    .replace(/\?(.*)/, '')
                    .replace(/\/(.*)/, '');
                if (firstUnmatchedPart === currentPath) {
                    // We finally found the tab to be opened
                    toBeSelectedTabFound = true;
                    break;
                }
                // if (toBeSelectedTabFound) {
                //     break;
                // }
            }
            if (!toBeSelectedTabFound && currentMatchedRouteTabIndex !== 0) {
                this.$router.push('/error404');
            } else {
                this.activeTabIndex = currentMatchedRouteTabIndex || 0;

                // e.g. router knows /navigation/page1
                //      user accesses /navigation/page1/whatever?queryParam=123
                // we store /navigation/page1 (key) -> /navigation/page1/whatever?queryParam=123 (value)
                // that allows us to RESTORE /navigation/page1/whatever?queryParam=123
                //  when the user navigates to /navigation/page1
                const payload: {
                    currentActiveRoutePath: string;
                    toBeRestoredUrl: string;
                } = {
                    currentActiveRoutePath: lastMatchedRecord.path,
                    toBeRestoredUrl: origPathBrowserIsAdressing
                };
                this.$store.commit('persistRouteSettings', payload);
            }
        }
    }

    close() {
        this.$emit('close');
    }
}
